/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import css from './PriceCard.desktop.scss';
import { getFormattedAmount } from 'Helpers/numbers';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getLocale } from 'Selectors/config';
import { FormattedMessage as Translation } from 'react-intl';
import { useExperiment } from 'LaquesisEOL/useExperiment';
import { getMinimumEmiForMinHitchAmountWithPeriod, getMinimumHitchAmount } from 'Selectors/financeConfig';
import { EMI_EXPERIMENT, PRICE_CARD_TAB_EXPERIMENT, CTA_MAP } from 'Constants/items';
import Button from 'Components/Button/Button';
import { noop } from 'Helpers/function';
import PriceCardTabs from './components/PriceCardTabs/PriceCardTabs';
import usePriceCardTabsExperiment from './hooks/usePriceCardTabsExperiment';

import withConfig from 'HOCs/withConfig/withConfig';
// import { Link } from 'react-router-dom';
import ReservationIconBtn from 'Components/ReservationIconBtn/ReservationIconBtn';
import PopUpReservationCoach from 'Components/ReservationPopUpCoach/ReservationPopUpCoach';

export const PriceCard = props => {
    const {
        displayPrice,
        minEmi,
        minHitchAmount,
        currencySymbol,
        currentLocale,
        onConsumerFinancingLinkClick,
        siteCode,
        showNewDesign,
        onSetFireMakeOffer,
        isMyItem,
        showMakeOffer,
        enableEmiFeature,
        actionButtons,
        brandPromise,
        down_payment,
        monthly_installment,
        tenure,
        dealerType,
        hasPromotion,
        discountedPriceDisplay,
        isShowCoachMark,
        onCloseMarkCoach,
        isShowReservationButton,
        isItemReserved,
        categoryId,
        primaryCTA,
        escrowTrack
    } = props;

    const variant = useExperiment(EMI_EXPERIMENT[siteCode] || '');
    const priceCardTabVariant = useExperiment(PRICE_CARD_TAB_EXPERIMENT || '');

    const objMonthlyTenur = {
        amount: monthly_installment,
        tenure
    };

    const renderReservationButtonContainer = ({
        isShowReservationButton,
        isShowCoachMark,
        onCloseMarkCoach,
        categoryId,
        isItemReserved,
        escrowTrack
    }) => {
        if (!isShowReservationButton) {
            return null;
        }

        return (
            <div>
                {isShowCoachMark && <div className={ css.overlay } />}
                <div className={ css.buttonReservationContainer }>
                    {isShowCoachMark && (
                        <div>
                            <div className={ css.popup }>
                                <PopUpReservationCoach onClose={ onCloseMarkCoach } categoryId={ categoryId } />
                            </div>
                            <div className={ css.blockContent } />
                        </div>
                    )}
                    <div
                        className={ css.reservationLink }
                        onClick={ () => escrowTrack() }
                    >
                        <ReservationIconBtn disabledButton={ isItemReserved } />
                    </div>
                </div>
            </div>
        );
    };

    usePriceCardTabsExperiment();
    const getContent = showNewDesign => {
        if (showNewDesign) {
            const handleMakeOfferTap = () => {
                onSetFireMakeOffer(true);
            };

            return (
                <>
                    {hasPromotion
                        ? <>
                            <div className={ css.promoPriceContainer }>
                                <div className={ css.strikeThroughPriceValue } data-aut-id="strikeThroughPrice">{displayPrice}</div>
                            </div>
                            <div className={ css.mainInfo } data-aut-id="itemPrice">{discountedPriceDisplay}</div>
                        </>
                        : <div className={ css.mainInfo } data-aut-id="itemPrice">{displayPrice}</div>
                    }

                    {/* OLX/Desktop/ADP */}
                    {(dealerType === 'OLX_Autos' || dealerType === 'Franchise' || dealerType === 'Preferred') && (
                        monthly_installment !== '0' && (
                            <div className={ css.cardAdp }>
                                <div className={ css.titleAdp }>
                                    <Translation id="estimatedCredit" />
                                </div>
                                <div className={ css.adpWrapper }>
                                    <div className={ css.labelAdp }>
                                        <Translation id="downPayment" />
                                    </div>
                                    <div className={ css.amountAdp } data-aut-id="itemAdp">
                                        {down_payment}
                                    </div>
                                </div>
                                <div className={ css.adpWrapper }>
                                    <div className={ css.labelAdp }>
                                        <Translation id="installment" />
                                    </div>
                                    <div className={ css.amountAdp } data-aut-id="itemAdp">
                                        <Translation id="installmentTenure" values={ objMonthlyTenur } />
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                    {renderReservationButtonContainer({
                        isShowReservationButton,
                        isShowCoachMark,
                        onCloseMarkCoach,
                        categoryId,
                        isItemReserved,
                        escrowTrack
                    })}
                    {
                        !isShowReservationButton && showMakeOffer
                        && !isMyItem
                        && <div className={ css.makeOfferWrapper }>
                            <Button
                                className={ css.makeOfferCta }
                                onClick={ handleMakeOfferTap }
                                type={ CTA_MAP.SHOW_MAKE_OFFER_CTA === primaryCTA ? 'primary' : 'secondaryBtn' }
                                fixed
                                data-aut-id="make-offer"
                                icon={ 'makeOffer' }
                            >
                                <Translation id="makeOffer" />
                            </Button>
                        </div>
                    }
                </>
            );
        }

        if (!enableEmiFeature) {
            return (
                <div>
                    {hasPromotion
                        ? <>
                            <div className={ css.promoPriceContainer }>
                                <div className={ css.strikeThroughPriceValue } data-aut-id="strikeThroughPrice">{displayPrice}</div>
                            </div>
                            <div className={ css.mainInfo } data-aut-id="itemPrice">{discountedPriceDisplay}</div>
                        </>
                        : <div className={ css.mainInfo } data-aut-id="itemPrice">{displayPrice}</div>
                    }
                    {/* OLX AUTOS/Desktop/ADP */}
                    {(dealerType === 'OLX_Autos' || dealerType === 'Franchise' || dealerType === 'Preferred') && (
                        monthly_installment !== '0' && (
                            <div className={ css.cardAdp }>
                                <div className={ css.titleAdp }>
                                    <Translation id="estimatedCredit" />
                                </div>
                                <div className={ css.adpWrapper }>
                                    <div className={ css.labelAdp }>
                                        <Translation id="downPayment" />
                                    </div>
                                    <div className={ css.amountAdp } data-aut-id="itemAdp">
                                        {down_payment}
                                    </div>
                                </div>
                                <div className={ css.adpWrapper }>
                                    <div className={ css.labelAdp }>
                                        <Translation id="installment" />
                                    </div>
                                    <div className={ css.amountAdp } data-aut-id="itemAdp">
                                        <Translation id="installmentTenure" values={ objMonthlyTenur } />
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                    {renderReservationButtonContainer({
                        isShowReservationButton,
                        isShowCoachMark,
                        onCloseMarkCoach,
                        categoryId,
                        isItemReserved,
                        escrowTrack
                    })}
                </div>
            );
        }

        const formattedMinEmi = getFormattedAmount(minEmi.emi, currencySymbol, currentLocale);
        const formattedHitchAmountEmi = getFormattedAmount(minHitchAmount, currencySymbol, currentLocale);

        if (variant === 'b') {
            return (
                <>
                    {
                        formattedMinEmi && <>
                            <div className={ css.mainInfo } data-aut-id="itemEmi">
                                <span className={ css.mainInfoLabel }>
                                    <Translation id="priceCardEmi">{txt => txt}</Translation>
                                </span>
                                {formattedMinEmi}
                                <span className={ css.mainInfoSubText }>x {minEmi.repaymentPeriodCount}</span>
                            </div>
                        </>
                    }
                    {formattedHitchAmountEmi && <div className={ css.otherInfo } data-aut-id="itemHitchAmount">
                        <Translation id="priceCardDownPayment">{txt => txt}</Translation>&nbsp;
                        <span className={ css.boldText }>{formattedHitchAmountEmi}</span>
                    </div>
                    }
                    {renderReservationButtonContainer({
                        isShowReservationButton,
                        isShowCoachMark,
                        onCloseMarkCoach,
                        categoryId,
                        isItemReserved,
                        escrowTrack
                    })}
                    {!isShowReservationButton && <div className={ css.otherInfo } data-aut-id="itemPrice">
                        <Translation id="priceCardLabel">{txt => txt}</Translation>&nbsp;
                        <span className={ css.boldText }>{displayPrice}</span>
                        <span className={ css.cfLink } onClick={ onConsumerFinancingLinkClick } role="button">
                            <Translation id="priceCardConsumerFinanceLink">{txt => txt}</Translation>
                        </span>
                    </div>}
                </>
            );
        }
        return (
            <>
                <div className={ css.mainInfo } data-aut-id="itemPrice">{displayPrice}</div>
                {
                    formattedMinEmi && <div data-aut-id="itemEmi">
                        <Translation id="priceCardEmi">{txt => txt}</Translation>&nbsp;
                        <span className={ cx(css.boldText, css.noSpaceRight) }>{formattedMinEmi} X {minEmi.repaymentPeriodCount}</span>
                    </div>
                }
                {
                    formattedHitchAmountEmi && <div data-aut-id="itemHitchAmount" className={ css.itemHitchAmount }>
                        <Translation id="priceCardDownPayment">{txt => txt}</Translation>&nbsp;
                        <span className={ css.boldText }>{formattedHitchAmountEmi}</span>
                        <span className={ css.cfLink } onClick={ onConsumerFinancingLinkClick } role="button">
                            <Translation id="consumerFinanceLink">{txt => txt}</Translation>
                        </span>
                    </div>
                }
                {renderReservationButtonContainer({
                    isShowReservationButton,
                    isShowCoachMark,
                    onCloseMarkCoach,
                    categoryId,
                    isItemReserved,
                    escrowTrack
                })}
            </>
        );
    };

    return (
        <div className={ cx(css.container, { [css.tabsWrapper]: Boolean(priceCardTabVariant) }) } data-aut-id="priceCard">
            {priceCardTabVariant === 'b' ? <PriceCardTabs { ...props } /> : getContent(showNewDesign)}
            { brandPromise }
            { actionButtons }
        </div>
    );
};

PriceCard.propTypes = {
    displayPrice: PropTypes.string,
    config: PropTypes.object,
    user: PropTypes.object,
    minEmi: PropTypes.shape({
        emi: PropTypes.number,
        repaymentPeriodCount: PropTypes.number
    }),
    minHitchAmount: PropTypes.number,
    currencySymbol: PropTypes.shape({
        pre: PropTypes.string,
        post: PropTypes.string
    }),
    currentLocale: PropTypes.string,
    onConsumerFinancingLinkClick: PropTypes.func,
    siteCode: PropTypes.string.isRequired,
    onSetFireMakeOffer: PropTypes.func,
    showNewDesign: PropTypes.bool,
    isMyItem: PropTypes.bool,
    showMakeOffer: PropTypes.bool,
    enableEmiFeature: PropTypes.bool,
    actionButtons: PropTypes.element,
    brandPromise: PropTypes.element,
    down_payment: PropTypes.string,
    monthly_installment: PropTypes.string,
    tenure: PropTypes.number,
    dealerType: PropTypes.string,
    hasPromotion: PropTypes.bool,
    discountedPriceDisplay: PropTypes.string,
    discountAmountValue: PropTypes.number,
    isShowCoachMark: PropTypes.bool,
    onCloseMarkCoach: PropTypes.func,
    isShowReservationButton: PropTypes.bool,
    isItemReserved: PropTypes.bool,
    categoryId: PropTypes.string,
    primaryCTA: PropTypes.string,
    escrowTrack: PropTypes.func
};

PriceCard.defaultProps = {
    displayPrice: '',
    minEmi: {},
    minHitchAmount: 0,
    currencySymbol: {},
    currentLocale: '',
    onConsumerFinancingLinkClick: noop,
    showMakeOffer: false,
    enableEmiFeature: false,
    actionButtons: null,
    brandPromise: null,
    down_payment: '0',
    monthly_installment: '0',
    tenure: 0,
    dealerType: '',
    hasPromotion: false,
    discountedPriceDisplay: '0',
    discountAmountValue: 0
};

export const mapStateToProps = (state, props) => ({
    currentLocale: getLocale(state),
    minEmi: getMinimumEmiForMinHitchAmountWithPeriod(state, {
        carValue: props.priceValue,
        enableEmiFeature: props.enableEmiFeature
    }),
    minHitchAmount: getMinimumHitchAmount(state, {
        carValue: props.priceValue,
        enableEmiFeature: props.enableEmiFeature
    })
});

export default compose(
    withConfig,
    connect(mapStateToProps, null),
    React.memo
)(PriceCard);
